import * as api from './api'
import * as userAPI from '../users/api'
import * as reducers from './slice-reducers'
import { AppDispatch } from 'src/app/store'
import { existUserAPI } from '../users/api'
import { setUser, setCurrency } from 'src/features'
import { editCompanyDetails } from '../companies/actions'
import { getUserDataTransformed } from './transformers/user-transformer'
import { mustRefreshTheToken, updateAuthCookiesAndLocalStorage } from 'src/core/helpers'
import { CompleteInfoPayload, LoginFormPayload, RegisterStateType, User } from 'src/core/models'
import { getBalanceAPI } from '../summary/summaryAPI'

export const registerNewUser = (payload: RegisterStateType, language: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCreateUserLoading(true))
    const body = getUserDataTransformed(payload, language)
    const filterResp = await existUserAPI(body.email)
    if (filterResp !== 'SUCCESS') { throw filterResp }
    await api.registerUserAPI(body)
    dispatch(reducers.setCreateUserLoading(false))
    dispatch(reducers.setCreateUserSuccess(true))
  } catch (error) {
    if (error === 'ALREADY_EXIST') {
      dispatch(reducers.setCreateUserError('ALREADY_EXIST'))
    } else {
      dispatch(reducers.setCreateUserError(error?.response?.data?.message))
    }
    dispatch(reducers.setCreateUserLoading(false))
    dispatch(reducers.setCreateUserSuccess(false))
  }
}

export const requestRestorePassword = (email: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setForgotPasswordLoading(true))
    await api.requestRestorePassword({ email })
    dispatch(reducers.setForgotPasswordLoading(false))
    dispatch(reducers.setForgotPasswordSuccess(true))
  } catch (error) {
    dispatch(reducers.setForgotPasswordLoading(false))
    dispatch(reducers.setForgotPasswordSuccess(false))
    dispatch(reducers.setForgotPasswordError(error))
  }
}

export const restorePassword = (payload: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setRestorePasswordLoading(true))
    await api.restorePasswordAPI(payload)
    dispatch(reducers.setRestorePasswordLoading(false))
    dispatch(reducers.setRestorePasswordSuccess(true))
  } catch (error) {
    dispatch(reducers.setRestorePasswordLoading(false))
    dispatch(reducers.setRestorePasswordSuccess(false))
    dispatch(reducers.setRestorePasswordError(error))
  }
}


export const loginUser = (payload: LoginFormPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setLoginLoading(true))
    const { token } = await api.loginUserAPI(payload)
    if (token) {
      updateAuthCookiesAndLocalStorage(token)
      getBalanceAPI()
      const prevRoute = localStorage?.getItem('prevRoute')
      if (prevRoute?.includes('/accounts')) {
        const user: User = await userAPI.fetchAuthenticatedUser()
        dispatch(setUser(user))
        dispatch(setCurrency(user?.currency_token_code))
      }
    }
    dispatch(reducers.setLoginLoading(false))
    dispatch(reducers.setLoginSuccess(true))
  } catch (error) {
    const data = error.response && error.response.data
    if (data?.non_field_errors?.length > 0) {
      dispatch(reducers.setLoginError(data.non_field_errors[0]))
    }
    dispatch(reducers.setLoginLoading(false))
    dispatch(reducers.setLoginSuccess(false))
  }
}

export const verifyEmail = (code: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setVerifyEmailLoading(true))
    await api.verifyEmailAPI(code)
    dispatch(reducers.setVerifyEmailLoading(false))
    dispatch(reducers.setVerifyEmailSuccess(true))
  } catch (error) {
    dispatch(reducers.setVerifyEmailLoading(false))
    dispatch(reducers.setVerifyEmailSuccess(false))
    dispatch(reducers.setVerifyEmailError(error))
  }
}

export const completeUserInfo = (code: string, payload: CompleteInfoPayload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCompleteUserInfoLoading(true))
    const companyId: number = await api.completeUserInfoAPI(code, payload)
    if(payload.companyFiles){
      dispatch(editCompanyDetails(companyId, payload.companyFiles.filesData, false))
    }
    dispatch(reducers.setCompleteUserInfoSuccess(true))
    dispatch(reducers.setCompleteUserInfoLoading(false))
  } catch (error) {
    dispatch(reducers.setCompleteUserInfoLoading(false))
    dispatch(reducers.setCompleteUserInfoSuccess(false))
    dispatch(reducers.setCompleteUserInfoError(error))
  }
}

export const verifyToken = (token: string) => async (dispatch: AppDispatch) => {
  try {
    const newToken = await api.validTokenAPI(token)
    if (mustRefreshTheToken(newToken)) {
      const tokenRefreshed = await api.refreshTokenAPI(newToken)
      updateAuthCookiesAndLocalStorage(tokenRefreshed)
    }
  } catch (error) {
    if (error?.response?.data?.non_field_errors) {
      dispatch(reducers.setVerifyTokenRedirectLogin(true))
    }
  }
}
